import { useState, useRef } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import Logo from "../../icons/mibgas";
import { login } from "../../services/auth.service";
import Button from "../../components/button";
import styles from "./styles.module.css";

import { withRouter } from "../../common/with-router";

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

const Login = ({ router }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const formRef = useRef(null);
  const checkBtnRef = useRef(null);

  const handleLogin = (e) => {
    e.preventDefault();

    setMessage("");
    setLoading(true);

    formRef.current.validateAll();

    if (checkBtnRef.current.context._errors.length === 0) {
      login(username, password).then(
        () => {
          router.navigate("/last");
          window.location.reload();
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();

          setLoading(false);
          setMessage(resMessage);
        }
      );
    } else {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.logoContainer}>
          <Logo />
        </div>
        <Form onSubmit={handleLogin} ref={formRef} className={styles.form}>
          <div className={styles.formGroup}>
            <label htmlFor="username" className={styles.formLabel}>
              Username
            </label>
            <Input
              type="text"
              className={styles.formInput}
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              validations={[required]}
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="password" className={styles.formLabel}>
              Password
            </label>
            <Input
              type="password"
              className={styles.formInput}
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              validations={[required]}
            />
          </div>
          <Button
            type="submit"
            variant="primary"
            disabled={loading}
            className="mt-4"
          >
            <span>Login</span>
          </Button>

          {message && (
            <div className={styles.alert}>
              <div
                className={`alert alert-danger ${styles.alertDanger}`}
                role="alert"
              >
                {message}
              </div>
            </div>
          )}
          <CheckButton className={styles.checkButton} ref={checkBtnRef} />
        </Form>
      </div>
    </div>
  );
};

export default withRouter(Login);
